import {
  GetDoctorDetailsByIdActionTypes,
  GET_DOCTOR_DETAILS_BY_ID_FAIL,
  GET_DOCTOR_DETAILS_BY_ID_LOADING,
  GET_DOCTOR_DETAILS_BY_ID_SUCCESS,
  GetDoctorDetailsByIdState,
  GET_DOCTOR_DETAILS_BY_ID_UPDATE_API_MSG,
  GET_DOCTOR_DETAILS_BY_ID_UPDATE_API_RES,
} from "./ActionTypes";
import { GetDoctorDetailsByIdRes } from "./Model";

const initialStateGetPosts: GetDoctorDetailsByIdState = {
  loading: false,
  getDoctorDetailsByIdRes: {} as GetDoctorDetailsByIdRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getDoctorDetailsByIdReducer = (
  state = initialStateGetPosts,
  action: GetDoctorDetailsByIdActionTypes
): GetDoctorDetailsByIdState => {
  switch (action.type) {
    case GET_DOCTOR_DETAILS_BY_ID_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_DOCTOR_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        getDoctorDetailsByIdRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_DOCTOR_DETAILS_BY_ID_FAIL:
      return {
        ...state,
        getDoctorDetailsByIdRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_DETAILS_BY_ID_UPDATE_API_MSG:
      return {
        ...state,
        getDoctorDetailsByIdRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_DETAILS_BY_ID_UPDATE_API_RES:
      return {
        ...state,
        getDoctorDetailsByIdRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
